import { matchRangesForTerms } from "@caliu/utils";

export interface MatchSegment {
  text: string;
  match: boolean;
}

/**
 * Split `text` into segments, flagging every case-insensitive occurrence of
 * each of `terms` (a search's `highlights`) as a match. Used by the command
 * palette to highlight the part of a result that matched the search.
 */
export function matchSegments(text: string, terms: string[]): MatchSegment[] {
  const segments: MatchSegment[] = [];
  let i = 0;
  for (const [start, end] of matchRangesForTerms(text, terms)) {
    if (start > i) segments.push({ text: text.slice(i, start), match: false });
    segments.push({ text: text.slice(start, end), match: true });
    i = end;
  }
  if (i < text.length || segments.length === 0) segments.push({ text: text.slice(i), match: false });
  return segments;
}
